import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Checkbox, Divider, FormControlLabel, Typography } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import * as lodash from 'lodash';
import { memo, useCallback, useMemo, } from 'react';
import { TreeViewString } from 'shared/device.z3k.tree-view-compare/ui/tree-view-string';
import { TreeViewWithoutNester } from 'shared/device.z3k.tree-view-compare/ui/tree-view-without-nester';
import { TreeViewNesterTree } from 'shared/device.z3k.tree-view-compare/ui/tree-view-nester-tree';
import 'shared/translate-config/i18n';
import { useTranslation } from 'react-i18next';
import { Suspense } from 'react';
export const ComponentThreeViewCompare = memo(function ComponentThreeViewCompare(props) {
    const { t } = useTranslation();
    const { title, resultCompare, keyResult, onCheckNewConfig, newSetter, flagAllCheckbox, } = props;
    const keyForDisables = useMemo(() => (keyResult === 'old' ? 'new' : 'old'), [keyResult]);
    const expendedTree = useMemo(() => resultCompare[keyResult]?.map((e, i) => `${i}`), [resultCompare, keyResult]);
    const arrForAll = useMemo(() => resultCompare[keyResult]
        ?.map((data) => {
        let allArgument = [];
        for (const i of data.el) {
            if (Array.isArray(i.setter)) {
                for (const e of i.setter) {
                    allArgument = [
                        ...allArgument,
                        {
                            key: data.key,
                            keyResult: keyResult,
                            el: e,
                            ...(i.name && { name: i.name }),
                            ...(i.flag && { flag: i.flag }),
                            ...(i.idSensor && { idSensor: i.idSensor }),
                        },
                    ];
                }
            }
            else {
                allArgument = [
                    ...allArgument,
                    {
                        key: data.key,
                        keyResult: keyResult,
                        el: i.setter,
                        ...(i.name && { name: i.name }),
                        ...(i.flag && { flag: i.flag }),
                        ...(i.idSensor && { idSensor: i.idSensor }),
                    },
                ];
            }
        }
        return allArgument;
    })
        .flatMap((value) => value), [keyResult, resultCompare]);
    const onChangeAll = useCallback((event) => {
        if (flagAllCheckbox && onCheckNewConfig) {
            onCheckNewConfig(event, arrForAll);
            return (flagAllCheckbox.current = {
                checked: event.target.checked,
                key: keyResult,
            });
        }
        return;
    }, [arrForAll, flagAllCheckbox]);
    return (_jsx(Suspense, { fallback: "loading", children: _jsxs(Box, { sx: { p: '10px' }, children: [_jsxs(Typography, { children: [title, ":"] }), onCheckNewConfig && (_jsx(FormControlLabel, { label: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435", control: _jsx(Checkbox, { checked: flagAllCheckbox?.current?.checked &&
                            flagAllCheckbox?.current?.key === keyResult, disabled: flagAllCheckbox?.current?.checked &&
                            flagAllCheckbox?.current?.key === keyForDisables, onChange: (event) => onChangeAll(event) }) })), _jsx(Divider, { orientation: 'horizontal', sx: { mb: '15px' } }), expendedTree && expendedTree.length > 0 && (_jsx(SimpleTreeView, { multiSelect: !!onCheckNewConfig, defaultExpandedItems: expendedTree, "aria-label": 'Tree result compare', children: resultCompare[keyResult]?.map((data, indexSetter) => {
                        //tree для компонентов где настройки don`t object or array
                        return (
                        //@ts-ignore
                        data.key !== 'unknown' &&
                            (lodash.isPlainObject(data.el[0].setter) ? (_jsx(TreeViewString, { indexSetter: indexSetter, data: data, newSetter: newSetter, keyResult: keyResult, onCheckNewConfig: onCheckNewConfig }, data.key)) : (
                            //tree для остальных с условием name, flag
                            _jsx(TreeItem, { itemId: `${indexSetter}`, label: _jsx(Typography, { variant: "inherit", children: t(`${data.key}.key`) }), children: _jsx(SimpleTreeView, { multiSelect: !!onCheckNewConfig, 
                                    //@ts-ignore
                                    defaultExpandedItems: data.el.map((component) => component.name), "aria-label": 'Tree setter for name settings', children: data.el?.map((component, index) => {
                                        if (component.name && !component.flag) {
                                            return (
                                            //компонент с вложенным разветвленным tree
                                            _jsx(TreeViewNesterTree, { component: component, data: data, newSetter: newSetter, keyResult: keyResult, onCheckNewConfig: onCheckNewConfig }, `${component.name}+${component.idSensor}`));
                                        }
                                        else {
                                            return (_jsx(TreeViewWithoutNester, { component: component, data: data, newSetter: newSetter, keyResult: keyResult, onCheckNewConfig: onCheckNewConfig }, index));
                                        }
                                    }) }) }, data.key))));
                    }) }))] }) }));
});
